import { Stripe } from "@stripe/stripe-js";
import { loadStripe } from "@stripe/stripe-js/pure";

let stripePromise: Promise<Stripe | null>;

export default function getStripe(): Promise<Stripe | null> {
  loadStripe.setLoadParameters({ advancedFraudSignals: false });
  if (!stripePromise) {
    const key = process.env.NEXT_PUBLIC_CLIENT_STRIPE_API_KEY || process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY;
    if (!key) {
      throw new Error("Stripe publishable key is not configured");
    }
    stripePromise = loadStripe(key);
  }

  return stripePromise;
}
